<template>
    <div class="conter">
        <div class="top-txt">用户填写信息</div>
        <div class="form-list">
            <!-- <div class="warp">
              <div>业主姓名</div>
              <input type="text" v-model="name" placeholder="请输入业主姓名" />
            </div>
            <div class="warp">
              <div>业主电话</div>
              <input
                type="text"
                v-model="phone"
                placeholder="请输入业主电话"
                maxlength="11"
              />
            </div> -->
            <div class="warp">
                <div>项目地址</div>
                <div @click="openAddressMap()">
                    <input
                            type="text"
                            v-model="oAddress.name"
                            readonly
                            placeholder="点击获取项目地址"
                    />
                </div>
            </div>
            <!-- <div class="warp">
              <div>业主性别</div>
              <div class="bottom_icon" @click="bGenderShow = !bGenderShow">
                {{ objName }}
              </div>
              <div class="selcet_bottom" v-if="bGenderShow">
                <ul>
                  <li
                    v-for="(item, index) in arrGender"
                    :key="index"
                    @click="getGender(item.name, item.id)"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
            </div> -->
        </div>
        <div class="submintbtn" @click="getSubmint">下一步</div>
        <!-- 选择地址 -->
        <el-select-address-map
                :nCityId.sync="nCityId"
                :arrCity="arrCity"
                :bShowMap.sync="bShowMap"
                :nLat.sync="nLat"
                :nLng.sync="nLng"
                :oAddress.sync="oAddress"
                :inputText="sGetAddress"
                :selectText="sGetCity"
        ></el-select-address-map>
    </div>
</template>
<script>
import oStorage from '@/libsV2/storage.js';
    import elSelectAddressMap from "@/components/selectAddressMap/index.vue";
    import {Toast} from "mint-ui";
    import oForm from "@/js/form.js";
    import {geoGetLocation} from "@/js/wx.js";

    export default {
        components: {
            Toast,
            elSelectAddressMap,
        },
        data() {
            return {
                bGenderShow: false, //控制性别弹窗显示隐藏
                bShowMap: false,
                nCityId: "", //城市id
                arrGender: [
                    {name: "男", id: 1},
                    {name: "女", id: 2},
                ],
                objName: "", //选择的性别
                nLng: null, //经度
                nLat: null, //纬度
                sGetAddress: '', // 点击获取到的地址
                sGetCity: '', // 获取到的市

                objNumber: 1,
                name: "", //业主姓名
                phone: "", //业主电话
                oAddress: {
                    //项目地址
                    name: "",
                },
                arrCity: [],
            };
        },
        created() {
            //本地信息
            let userInfo = this.$storage.getStorage("userinfo");
            // this.name = userInfo.name || "";
            // this.phone = userInfo.phone || "";
            $init((res) => {
                this.getTree();
            });
        },
        methods: {
            openAddressMap() {
                let address = '';
                address = this.$storage.getStorage("userinfo").address;
                // if (this.oAddress.name) {
                //     this.nLng = this.oAddress.location.lng
                //     this.nLat = this.oAddress.location.lat
                //     address = this.oAddress.name
                // } else {

                // }

                // '上海市嘉定区云谷路599号'
                geoGetLocation(address).then(res => {
                    //  console.log("点击input>>>", address, res);
                    this.sGetAddress = res.geocodes[0].formattedAddress;
                    this.sGetCity = res.geocodes[0].addressComponent.city;
                    this.nLng = res.geocodes[0].location.lng;
                    this.nLat = res.geocodes[0].location.lat;
                    this.bShowMap = true;
                }).catch(err => {
                    //  console.log("err>>>", err, JSON.parse(localStorage.getItem('addresInfo')));
                    // const addresInfo = JSON.parse(localStorage.getItem('addresInfo'));
                    const addresInfo = JSON.parse(oStorage.getStorage('addresInfo'));
                    this.sGetAddress = addresInfo.district + addresInfo.township + addresInfo.street + addresInfo.streetNumber;
                    this.sGetCity = addresInfo.city || addresInfo.province;
                    this.nLat = addresInfo.latitude;
                    this.nLng = addresInfo.longitude;
                    this.bShowMap = true;
                });
            },
            // 获取地址三级联动数据
            getTree() {
                oForm.getTree().then((res) => {
                    let arrTree = res.data.data.result;
                    let arrProvince = arrTree[0];
                    arrProvince.forEach((it) => {
                        it["value"] = it.name;
                        if (arrTree[it.id].length) {
                            it["children"] = arrTree[it.id];
                            it.children.forEach((sit) => {
                                sit["value"] = sit.name;
                                // sit['children'] = arrTree[sit.id]
                            });
                        }
                    });
                    arrProvince.splice(0, 1);
                    this.arrCity = arrProvince;
                });
            },
            getGender(name, nIndex) {
                this.objName = name;
                this.objNumber = nIndex;
                this.bGenderShow = false;
            },
            //提交表单
            getSubmint() {
                let that = this;
                // if (that.name == "") {
                //   Toast({
                //     message: "请输入业主姓名",
                //     position: "center",
                //     duration: 1200,
                //   });
                //   return false;
                // }
                // if (that.oAddress.name == "") {
                //   Toast({
                //     message: "请选择地址",
                //     position: "center",
                //     duration: 1200,
                //   });
                //   return false;
                // }
                // if (that.phone == "") {
                //   Toast({
                //     message: "请输入业主电话",
                //     position: "center",
                //     duration: 1200,
                //   });
                //   return false;
                // }
                // if (!/^1[3|4|5|8|6|9|][0-9]\d{8}$/.test(that.phone)) {
                //   Toast({
                //     message: "请输入正确的电话号码",
                //     position: "center",
                //     duration: 1200,
                //   });
                //   return false;
                // }
                // if (that.objName == "") {
                //   Toast({
                //     message: "请填写性别",
                //     position: "center",
                //     duration: 1200,
                //   });
                //   return false;
                // }
                let submintData = {
                    id: that.$route.query.ownerid,
                    // sex: that.objNumber,
                    name: that.name,
                    phone: that.phone,
                    address: that.oAddress.name,
                    nLng: that.nLng, //经度
                    nLat: that.nLat, //纬度
                    nCityId: that.nCityId,
                };
                that.$store.commit("setUserInfo", submintData);
                that.$router.push({
                    path: `/antV2/basicinfo`,
                });
                //  console.log(this.$store.state.projectInfo);
            },
        },
    };
</script>
<style lang="scss" scoped>
    @import "submit.scss";
</style>
